module.exports = __webpack_public_path__ + "cb2fc21b5c990f2cef75b1de5e7dd633.svg";